<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Kategorie bearbeiten') }}</h1>
        </div>

        <p>
            <a :href="category.permalink" target="_blank">{{ category.permalink }}</a>
        </p>

        <div class="">
            <form @submit.prevent="form.put(route('admin.categories.update', category))">
                <form-fields :form="form" :category="category" :category-options="categoryTree" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'category',
            'categoryTree',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    parent_id: this.category.parent_id,
                    name: this.category.name,
                    slug: this.category.slug,
                    image_id: this.category.image_id,
                    default_product_image_id: this.category.default_product_image_id,
                    sort_order: this.category.sort_order,
                    enabled: this.category.enabled,
                    mdr_classified_products: this.category.mdr_classified_products,
                    hazardous_material_products: this.category.hazardous_material_products,
                    keywords: this.category.keywords,
                    meta_title: this.category.meta_title,
                    meta_description: this.category.meta_description,
                    description: this.category.description,
                    notes: this.category.notes,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>